import React from 'react';
import { Modal } from '@mantine/core';
import { Button } from '../../../../../components/Button';
import navyModal from '../../../../../components/Modal/navy-modal.module.scss';
import { formatMoneyCompact } from '../../../../../utils/money';
import classes from './min-order-reminder-dialog.module.scss';

export type MinOrderReminderDialogProps = {
  opened: boolean;
  tableNumber: string;
  effectiveMinimum: number;
  currentTotal: number;
  missing: number;
  isBusy: boolean;
  onAddCompletion: () => void;
  onContinueWithout: () => void;
  onDismiss: () => void;
};

export const MinOrderReminderDialog: React.FC<MinOrderReminderDialogProps> = ({
  opened,
  tableNumber,
  effectiveMinimum,
  currentTotal,
  missing,
  isBusy,
  onAddCompletion,
  onContinueWithout,
  onDismiss,
}) => (
  <Modal
    opened={opened}
    onClose={onDismiss}
    title={<strong>מינימום הזמנה</strong>}
    centered
    radius="md"
    dir="rtl"
    classNames={{ root: navyModal.root }}
    zIndex={430}
    closeOnClickOutside={!isBusy}
    closeButtonProps={{ 'data-testid': 'min-order-reminder-close' } as Record<string, string>}
  >
    <div className={classes.stack} data-testid="min-order-reminder">
      <p className={classes.lead}>{`שולחן ${tableNumber} מתחת למינימום ההזמנה`}</p>
      <dl className={classes.rows}>
        <div className={classes.row}>
          <dt>מינימום הזמנה</dt>
          <dd data-testid="min-order-reminder-minimum">{`${formatMoneyCompact(effectiveMinimum)} ₪`}</dd>
        </div>
        <div className={classes.row}>
          <dt>סה"כ נוכחי</dt>
          <dd data-testid="min-order-reminder-current">{`${formatMoneyCompact(currentTotal)} ₪`}</dd>
        </div>
        <div className={`${classes.row} ${classes.rowStrong}`}>
          <dt>חסר להשלמה</dt>
          <dd data-testid="min-order-reminder-shortfall">{`${formatMoneyCompact(missing)} ₪`}</dd>
        </div>
      </dl>
      <div className={classes.actions}>
        <Button variant="cancel" onClick={onContinueWithout} disabled={isBusy} dataTestId="min-order-reminder-skip">
          המשך בלי
        </Button>
        <Button
          variant="confirm"
          onClick={onAddCompletion}
          disabled={isBusy}
          loading={isBusy}
          loadingLabel="מוסיף..."
          dataTestId="min-order-reminder-add"
        >
          הוסף השלמה למינימום הזמנה
        </Button>
      </div>
    </div>
  </Modal>
);
